export default __webpack_public_path__ + "static/media/arrow-02-red.586ee71d.svg";